







































































import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
import * as amplitude from 'amplitude-js';
import services from '@/services';
import { VirtualLookDTO } from '@/api';
import { clientsModule } from '@/store';
import EditingLayout from '@/layouts/EditingLayout.vue';
import LookDynamicCard from '@/components/looks/LookDynamicCard.vue';
import IconArrowLeft from '@/assets/icons/arrow-left.svg';
import IconAddComment from '@/assets/icons/add-comment.svg';
import IconFilter from '@/assets/icons/filters.svg';
import { throwError } from '@/utils';
import { Groups } from '@/utils/looks.utils';
import AiParams from '@/components/ai/AiParams.vue';

@Component({
  name: 'ai-looks-client-things-page',
  components: {
    EditingLayout, LookDynamicCard, IconArrowLeft, IconAddComment, IconFilter, AiParams,
  },
})
export default class AiLooksClientThingsPage extends Vue {
  looks: VirtualLookDTO[] = [];

  loading = false;

  form = {
    score: 1,
    comment: '',
  }

  selected: number[] = [];

  created() {
    amplitude.getInstance().logEvent('Открыта страница аи луков из вещей клиента');
    this.fetchLooks();
  }

  async fetchLooks() {
    try {
      this.loading = true;
      if (this.client && this.client.id != null) {
        if (this.$route.name === 'ai-looks-from-clients-things' || this.$route.name === 'compilation-ai-looks-from-clients-things') {
          const { data: looks } = await services.aiApi()
            .aiEndpointClientThingsLooks(this.client.id);
          this.looks = looks;
        }
        if (this.$route.name === 'ai-looks-by-client-thing-from-clients-things' && this.$route.params.thingId) {
          const { data: looks } = await services.aiApi()
            .aiEndpointClientThingsLooks(this.client.id, Number(this.$route.params.thingId));
          this.looks = looks;
        }
        if (this.$route.name === 'ai-looks-by-catalog-thing-from-clients-things' && this.$route.params.itemId) {
          const { data: looks } = await services.aiApi()
            .aiEndpointClientThingsLooks(this.client.id, undefined,
              Number(this.$route.params.itemId));
          this.looks = looks;
        }
      }
    } catch (e) {
      throwError('Ошибка загрузки луков');
    } finally {
      this.loading = false;
    }
  }

  get groupedLooks() {
    return this.looks.map((look) => {
      const groups: Groups = {
        top2: [],
        bottom: [],
        top1: [],
        outerwear: [],
        dress: [],
        shoes: [],
        accessories: [],
        bag: [],
        jewelry: [],
      };
      (look.items || []).forEach((item) => {
        const key = item.aiType as keyof typeof groups | undefined;
        if (!key) return;
        groups[key].push(item);
      });
      return {
        ...look,
        groups,
      };
    });
  }

  get selectedLook() {
    return this.groupedLooks.find(look => look.id === this.selected[this.selected.length - 1]);
  }

  @Watch('selectedLook')
  updateForm(value: VirtualLookDTO) {
    this.form.score = value.userScore || 1;
    this.form.comment = value.comment || '';
  }

  get count() {
    return this.looks.length;
  }

  get options() {
    return this.$route?.meta?.options;
  }

  get client() {
    return clientsModule.model;
  }

  isSelected(id: number) {
    return this.selected.includes(id);
  }

  setSelected(id: number) {
    this.selected.push(id);
  }

  removeSelected(id: number) {
    const index = this.selected.findIndex(i => i === id);
    this.selected.splice(index, 1);
  }

  async addLookToSandbox() {
    if (this.client?.id != null) {
      // eslint-disable-next-line no-restricted-syntax
      for (const id of this.selected) {
        // eslint-disable-next-line no-await-in-loop
        await services.sandboxApi().sandboxEndpointAddVirtualLook(this.client.id, id);
      }
    }
    this.$notify({ type: 'success', title: 'Образы добавлены', message: 'Образы добавлены в песочницу' });
  }

  async addToCompilation() {
    if (this.client?.id != null && this.$route.params.compilationId) {
      // eslint-disable-next-line no-restricted-syntax
      for (const id of this.selected) {
        // eslint-disable-next-line no-await-in-loop
        await services.compilationsApi()
          .compilationEndpointAddAiLook(Number(this.$route.params.compilationId), id);
      }
    }
  }

  commentVirtualLook() {
    this.selected.forEach((selected) => {
      services.aiApi()
        .aiEndpointCommentVirtualLook(selected, this.form.score, this.form.comment);
    });
  }

  back() {
    this.$router.push({ name: this.options.back });
  }
}

